export const dialogPaperProps = {
  width: "100%",
  maxWidth: "556px",
  mx: "5px",
  borderRadius: 4,
  boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.08)",
};

export const missingModalField = {
  borderColor: "#2F2B3D38",
  color: "#2F2B3D",

  "& .MuiOutlinedInput-root": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "6px",
    padding: "0px",
    "& .MuiOutlinedInput-input": {
      padding: "6px",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "&[type=number]": {
        MozAppearance: "textfield",
      },
    },
    "&:hover fieldset": {
      borderColor: "#46a091",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#46a091",
    },
  },
  width: "100%",
  maxWidth: "528px",
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    py: "8px",
    px: "12px",
  },
};

export const modalActions = {
  p: {xs:"16px", sm: "24px"},
  justifyContent: "space-between",
};
